import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function LastWillStep(): ReactElement {
  const dispatch = useDispatch();
  const { willPossessed: willPossessed } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('has_will');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Last Will & Testament"
          subHeader="A will lays out exactly what happens with your kids and your assets when you
          pass away."
        />
      </GrayCard>
      <CardPadding>
        <CardHeader header="Do you have a will?" />
        <Formik
          initialValues={{ willPossessed }}
          onSubmit={onSubmit}
          validationSchema={createYesNoObjectSchema('willPossessed')}
        >
          <Form ref={formRef}>
            <YesOrNoStepCreator name="willPossessed" showNotSure={true} />

            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { LastWillStep };
